import styled from 'styled-components';

const CountrySales = styled.h6`
  margin: 0;
  font-weight: bold;
  color: ${({ theme }) => theme?.colors?.textPrimary || '#333'};

  @media (max-width: ${({ theme }) => theme?.breakpoints?.mobile || '768px'}) {
    font-size: ${({ theme }) => theme?.fontSizes?.small || '0.9rem'};
  }
`;

export default CountrySales;
